import { OwcHyperlink, OwcTypography, OwcIcon } from "@one/react";
import { GoogleAuth } from "../components/shared/GoogleAuth";

const UserProfile = ({ user, isBookingAdmin }) => {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', padding: '3px 16px', borderTop: "thin solid #C2BAB5" }}>
        <GoogleAuth showCalendarIcon={true} />
      </div>
      <div style={{ borderTop: "thin solid #C2BAB5", padding: "10px 16px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <OwcIcon
            id="icon-warning"
            type="outlined"
            name="notification"
            style={{ margin: '0 4px' }}
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
          <OwcHyperlink href={process.env.REACT_APP_LP_GRAPHQL_ENDPOINT_CLOUDFRONT + "notificationsApp"} target="_blank" style={{ color: 'var(--one-color-foreground-base-1)', cursor: 'pointer', fontWeight: 'normal', textDecoration: 'none' }}>
            Notification settings
          </OwcHyperlink>
        </div>
      </div>
      <div style={{ borderTop: "thin solid #C2BAB5", padding: "3px 16px", backgroundColor: "#FBFBFA" }}>
        <OwcTypography style={{ color: '#9D948E', fontSize: "12px", marginLeft: "9px", lineHeight: "normal" }}>Site</OwcTypography>
        <OwcTypography style={{ color: '#9D948E', fontSize: "16px", marginLeft: "9px", lineHeight: "normal" }}>{user.site}</OwcTypography>
      </div>
      <div style={{ borderTop: "thin solid #C2BAB5", borderBottom: "thin solid #C2BAB5", padding: "3px 16px", backgroundColor: "#FBFBFA" }}>
        <OwcTypography style={{ color: '#9D948E', fontSize: "12px", marginLeft: "9px", lineHeight: "normal" }}>Role</OwcTypography>
        <OwcTypography style={{ color: '#9D948E', fontSize: "16px", marginLeft: "9px", lineHeight: "normal" }}>{isBookingAdmin ? "Admin" : "User"}</OwcTypography>
      </div>
    </>
  );
};

export default UserProfile;
